module.exports = __webpack_public_path__ + "static/the-waves-海浪-c6d9e2dd9d6d9694ec17139adcae6795.jpg";